"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxonomyClassesSetInUseTerminalNodes = exports.taxonomyClassesSetIsLoading = exports.taxonomyClassesSetData = void 0;
const Actions = __importStar(require("../types/taxonomy-classes"));
const utils_1 = require("../utils");
const taxonomyClassesSetData = (data) => ((0, utils_1.createAction)(Actions.TAXONOMY_CLASSES_SET_DATA, data));
exports.taxonomyClassesSetData = taxonomyClassesSetData;
const taxonomyClassesSetIsLoading = (isLoading) => ((0, utils_1.createAction)(Actions.TAXONOMY_CLASSES_SET_IS_LOADING, { isLoading }));
exports.taxonomyClassesSetIsLoading = taxonomyClassesSetIsLoading;
const taxonomyClassesSetInUseTerminalNodes = (classes) => ((0, utils_1.createAction)(Actions.TAXONOMY_CLASSES_SET_IN_USE_TERMINAL_NODES, classes));
exports.taxonomyClassesSetInUseTerminalNodes = taxonomyClassesSetInUseTerminalNodes;
